// import React, { useState } from "react";
// import { TextInput, TextArea } from "../../Components/Inputs";
// import init_po from "../init_po";
// import Btn from "../../../../Components/Buttons/Btn";
// import { useNavigate } from "react-router-dom";

// const Edit = () => {
//   const [input, setInput] = useState(init_po);
//   const navigate = useNavigate();
//   return (
//     <div className="border-t shadow-2xl w-[85%] m-auto mt-12 p-5 rounded-md">
//       <h3 className="text-center text-xl font-semibold text-primary">
//         Edit Purchase Order
//       </h3>
//       <div className="mt-5">
//         <TextInput input={input} setInput={setInput} field="item_name" />
//         <div className="flex gap-5 max-md:flex-col max-md:w-full">
//           <TextInput input={input} setInput={setInput} field="quantity" />
//           <TextInput input={input} setInput={setInput} field="total_amount" />
//         </div>
//         <TextArea input={input} setInput={setInput} field="description" />
//       </div>
//       <div className="mt-5 flex justify-between">
//         <Btn onClick={() => navigate("/dashboard/purchase-orders")}>Back</Btn>
//         <Btn onClick={() => navigate("/dashboard/purchase-orders")}>Update</Btn>
//       </div>
//     </div>
//   );
// };

// export default Edit;

import React, { useEffect, useState } from "react";
import { TextInput, TextArea } from "../../Components/Inputs";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useForm from "../../Components/hooks/useForm";
import init_po from "../init_po";

const Edit = () => {
  const { id } = useParams();
  const [input, setInput] = useState(init_po);
  const navigate = useNavigate();
  const request = useAxios();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getPurchaseOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getPurchaseOrderDetails() {
    let res = await request({
      method: "get",
      url: `purchase-orders/single-po`,
      params: {
        id: parseInt(id),
      },
    });
    if (res === "error") return;

    // Map API response to your init_po structure with .value
    const inputCpy = { ...init_po };
    inputCpy.item_name.value = res?.item_name || "";
    inputCpy.quantity.value = res?.quantity?.toString() || "";
    inputCpy.total_amount.value = res?.total_cost?.toString() || "";
    inputCpy.description.value = res?.description || "";

    setInput(inputCpy);
  }

  const handleSubmit = async (data) => {
    setIsLoading(true);
    let res = await request({
      method: "PUT",
      url: `purchase-orders/update`,
      body: {
        id: parseInt(id),
        item_name: data.item_name,
        quantity: parseInt(data.quantity),
        total_cost: parseInt(data.total_amount),
        description: data.description,
      },
      show_loading: true,
      loadingFunc: setIsLoading,
    });
    if (res === "error") {
      setIsLoading(false);
      return;
    }
    navigate("/dashboard/purchase-orders");
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="shadow-2xl w-[85%] m-auto border-t p-4 mt-12 rounded-md">
      <h3 className="text-center text-xl font-semibold text-primary">
        Edit Purchase Order
      </h3>
      <div className="mt-4">
        <TextInput
          input={input}
          setInput={setInput}
          field="item_name"
          validate={validate}
        />
        <div className="flex gap-5 max-md:flex-col">
          <TextInput
            input={input}
            setInput={setInput}
            field="quantity"
            validate={validate}
          />
          <TextInput
            input={input}
            setInput={setInput}
            field="total_amount"
            validate={validate}
          />
        </div>
        <TextArea
          input={input}
          setInput={setInput}
          field="description"
          validate={validate}
        />
      </div>
      <div className="mt-4 flex justify-between">
        <Btn onClick={() => navigate("/dashboard/purchase-orders")}>Back</Btn>
        <Btn onClick={handleValidation} disabled={isLoading}>
          {isLoading ? "Updating..." : "Submit"}
        </Btn>
      </div>
    </div>
  );
};

export default Edit;
